import { useLocalStorage } from "./storage.hook";
import { useLocation, useNavigate } from "react-router-dom";
import { routes, tracRoutes } from "src/data/routes";
import { useContext } from "react";
import { AuthContext } from "src/context/authContext";
import { useUser } from "./user.hook";
import { getUser, login, resetPassword, verifyReset } from "src/api/http/auth";
import { Credentials, VeryPassworResetRequest } from "src/models/auth";
import { useAnalytics } from "./analytics.hook";
import { useAtom } from "jotai";
import { accountsAtom } from "src/store";
import { getAssociatedAccount } from "src/api/http/account";

export const useAuth = () => {
  const { user, addUser } = useUser();
  const { clearStorage, setObject } = useLocalStorage();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(AuthContext);
  const [accounts, setAccounts] = useAtom(accountsAtom);

  const { setUserId, onlogout } = useAnalytics();
  const location = useLocation();

  const loginRequest = async (credentials: Credentials): Promise<any> => {
    let result: any;
    setAccounts(null);
    result = await login(credentials);
    if (result instanceof Error) { return result }
    const user = await getUser(credentials.email);
    addUser(user.data);
    setObject('token', result.data);
    setUserId(user.data);
    const value = await getAssociatedAccount()
    setAccounts(value.data);
    setIsAuthenticated();
    if (value.data?.length > 1) {
      navigate(routes.ACCOUNTS)
    } else {
      navigate(routes.INVESTMENTS)
    }
    return result;
  };


  const resetPasswordRequest = async (email: string): Promise<any> => {
    let result: any;
    result = await resetPassword(email);
    if (result instanceof Error) { return result }
    return result;
  };

  const verifyResetRequest = async (data: VeryPassworResetRequest): Promise<any> => {
    let result: any;
    result = await verifyReset(data);
    if (result instanceof Error) { return result }
    return result;
  };

  const logout = () => {
    onlogout({
      page_current: tracRoutes.find((route) => location.pathname?.includes(route?.route))?.page
    }, user?.id);
    clearStorage();
    setIsAuthenticated();
    setUserId(null);
    navigate(routes.LOGIN);
  };


  return { user, login: loginRequest, logout, resetPassword: resetPasswordRequest, verifyReset: verifyResetRequest };
};
